/*
项目列表 1
项目详情 2
新闻列表 3
新闻详情 4
捐赠列表 5
*/
//配置导航
import router from '@/router'
export const getTemplate = (value, item) => {
  let param = {};
  switch (Number(value)) {
    case 1:
      param.path = "/project";
      param.name = "project";
      param.title = "name";
      param.desc = "desc";
      break;
    case 2:
      param.path = "/projectInfo";
      param.name = "projectInfo";
      param.title = "name";
      param.desc = "desc";
      break;
    case 3:
      param.path = "/dynamics";
      param.name = "dynamics";
      param.title = "title";
      param.desc = "description";
      break;
    case 4:
      param.path = "/overView";
      param.name = "overView";
      param.title = "title";
      param.desc = "description";
      break;
    case 5:
      param.path = "/donation";
      param.name = "donation";
      break;
    case 8:
      param.path = item.value;
      param.name = item.value;
      break;
    default:
      param.path = "/";
      param.name = "home";
  }
  return param;
}
function  getURL(url) {
  if(url!=""){
    var reg=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
    if(!reg.test(url)){
       return false
     }else{
      return true
    }
  }else{
    return false
  }
 
}
export const channelGoto = (item) => {
  if(item.type==4){
    if(getURL(item.content)){
      window.open(item.content, '_blank');
      return false
    }else{
      return false;
    }
  }
  if(item.template==8){
    if(item.target_type==1){
       window.open(item.path, '_blank');
    }else{
      window.location.href = item.path
    }
  }else{
    if(!item.path){
      item.path = getTemplate(item.template).path
    }
    
    if(!item.id&& item.path && item.name){
      router.push({ path: item.path, });
      return false
    }
    let id = item.id?item.id:''

    if(item.target_type==1){
      if(item.pid==0){
        let routeUrl = router.resolve({
            path: item.path,
            query: {id: id }
        });
        window.open(routeUrl .href, '_blank');
      }else{
         let routeUrl = router.resolve({
            path: item.path,
            query: { id: item.pid,second_navId: id} 
        });
        window.open(routeUrl .href, '_blank');
      }
    }else{
      if(item.pid==0){   
        if(item.path && (item.path=='/project' || item.path=='/donation' || item.path=='/dynamics')){
          router.push({ path: item.path, query: { id: id,page:1 } });
        }
        else  router.push({ path: item.path, query: { id: id } });
      }else{
        if(item.path && (item.path=='/project' || item.path=='/donation' || item.path=='/dynamics')){
          router.push({ path: item.path, query: { id: item.pid,second_navId: id,page:1} });
        }
        else router.push({ path: item.path, query: { id: item.pid,second_navId: id} });
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/func.js